// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const members = {
  getMembers(page) {
    return AuthService.get(`membership/members?page=${page}`);
  },
  showMembers(id) {
    return AuthService.get(`membership/members/${id}`);
  },
  createMembers(data) {
    return AuthService.post("membership/members", data);
  },
  updateMembers(id, data) {
    return AuthService.put(`membership/members/${id}`, data);
  },
  deleteMembers(id) {
    return AuthService.delete(`membership/members/${id}`);
  }
};
export default members;
